<template>
  <div class="share-dialog common-dialog" v-if="episode">
    <button class="close" @click="close">
      <icon-close></icon-close>
    </button>
    <div class="share-content">
      <div class="copy-code">
        <div class="form link-code ">
          <div class="title_panel">{{linkOrCodeName}}:</div>
          <input
              ref="input"
            @click="select($event)"
            :title="linkOrCodeTitle"
            type="text"
            class="input_link"
            :value="linkOrCodeContent"
          />
          <a
            href="javascript:void(0);"
            v-clipboard:copy="linkOrCodeContent"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"

            class="btn copy"
            >Copy</a
          >
        </div>
        <div class="icon-group form d-flex">
          <a
            @click="showLink"
            class="btn embed link"
            href="javascript:;"
            title="Episode Link"
          >
            <icon-link/>
          </a>
          <a
            @click="showCode"
            class="btn embed"
            href="javascript:;"
            title="Embed Code"
          >
            <icon-code></icon-code>
          </a>
          <a
            class="btn subscribe"
            v-if="$store.state.setting.podcastProtectedType != 'private'"
            :href="$store.state.setting.subscribeLink"
            target="_blank"
            title="RSS Feed"
          >
            <icon-subscribe />
          </a>
          <ul
              v-if="!tmpDisableAddThis"
              class="iconlist clearfix"
          >
            <li>
              <ShareNetwork
                  network="facebook"
                  :url="episode.shareLink || episode.link"
                  :title="episode.title"
                  :description="episode.title"
                  :quote="episode.title"
              >
              <span>
                <a> <i class="pbicon pbFont-facebook1"></i></a>
              </span>
              </ShareNetwork>
            </li>
            <li>
              <ShareNetwork
                  network="twitter"
                  :url="episode.shareLink || episode.link"
                  :title="episode.title"
                  :description="episode.title"
                  :quote="episode.title"
              >
                <span>
                  <a>
                     <i class="pbicon pbFont-twitter-x-round3"></i>
                  </a>
                </span>
              </ShareNetwork>
            </li>
            <li>
              <ShareNetwork
                  network="linkedin"
                  :url="episode.shareLink || episode.link"
                  :title="episode.title"
                  :description="episode.title"
                  :quote="episode.title"
              >
                <span>
                <a> <i class="pbicon pbFont-linkedin2"></i></a>
              </span>
              </ShareNetwork>
            </li>
            <li>
              <ShareNetwork
                  network="tumblr"
                  :url="episode.shareLink || episode.link"
                  :title="episode.title"
                  :description="episode.title"
                  :quote="episode.title"
              >
                <span>
                <a> <i class="pbicon pbFont-tumblr2"></i></a>
              </span>
              </ShareNetwork>
            </li>
            <li>
              <ShareNetwork
                  network="vk"
                  :url="episode.shareLink || episode.link"
                  :title="episode.title"
                  :description="episode.title"
                  :quote="episode.title"
              >
                <span>
                <a> <i class="pbicon pbFont-vk2"></i></a>
              </span>
              </ShareNetwork>
            </li>
          </ul>

        </div>
      </div>

    </div>
    <a class="podbean-logo" v-if="setting.pbad"
       href="http://www.podbean.com?utm_campaign=pb_web_audio_player&utm_medium=app_download&utm_source=pb_web_player"
       target="_blank">
        <icon-podbean-logo></icon-podbean-logo>
    </a>
  </div>
</template>

<script>
    import IconCode from "@/components/icons/IconCode";
    import IconSubscribe from "@/components/icons/IconSubscribe";
    import { mapGetters, mapState } from "vuex";
    import asyncLoadJs from "@/common/utils";
    import IconLink from "./icons/IconLink";
    import IconClose from "./icons/IconClose";
    import IconPodbeanLogo from "./icons/IconPodbeanLogo";
    import { sleep } from "../common/utils";
    import {MUTATION_UPDATE} from "@/store/mutations";

    export default {
  name: "ShareDialog",
  components: {IconPodbeanLogo, IconClose, IconLink, IconSubscribe, IconCode },
  mounted() {
    // if (window.addthis){
    //   console.log('window.addthis.toolbox')
    //
    //   window.addthis.toolbox('.addthis_toolbox')
    // }else{
    //   asyncLoadJs(
    //     "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5146bea7215915ab"
    //   );
    // }
  },
  computed: {
    ...mapGetters(["episode"]),
    ...mapState(["setting"]),
    showCompact(){
      return window.innerHeight > 400;
    },
    embedCode() {
      var iframe = document.createElement("iframe");
      iframe.setAttribute("title", this.episode.title);

      if (this.episode.protectedLevel !== "public") {
        iframe.setAttribute("referrerPolicy", "no-referrer-when-downgrade");
      }

      let width = "100%";
      let height = "150";
      if (this.$store.state.square === 1) {
        height = 400;
      } else if (this.episode.type === "video") {
        height = 480;
      } else if (this.$store.state.episodes.length > 1) {
        height = 315;
      }

      iframe.setAttribute("height", height);
      iframe.setAttribute("width", width);
      iframe.setAttribute("style", "border: none;");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("data-name", "pb-iframe-player");
      iframe.setAttribute("src", window.location.href);
      iframe.setAttribute("allowfullscreen", "");
      return iframe.outerHTML.replace(/&amp;/g, "&");
    },
  },
      watch:{
        async episode(){
          this.linkOrCodeContent = this.episode.shareLink || this.episode.link;
          this.tmpDisableAddThis = true;
          await sleep(100);
          this.tmpDisableAddThis = false;
          await this.$nextTick();
          if (window.addthis){
            window.addthis.toolbox(".addthis_toolbox");
          }
        },
      },
  data() {
    return {
      linkOrCodeContent: "",
      linkOrCodeTitle: "Episode link",
      linkOrCodeName: "Link",
      tmpDisableAddThis : false,
    };
  },
  created() {
    this.linkOrCodeContent = this.episode.shareLink || this.episode.link;
  },
  methods: {
    onCopy(){
      this.$toasted.show("Copied", {
        position: "bottom-center",
        duration : 2000
      });
        // this.$refs.input.select();
    },
    onError(){
      this.$toasted.show("Copy failed. Please manual copy it.", {
        position: "bottom-center",
        duration : 2000
      });
    },
    select(event){
      event.target.select();
    },
    showLink(){
      this.linkOrCodeContent = this.episode.shareLink || this.episode.link;
      this.linkOrCodeTitle =  "Episode link";
      this.linkOrCodeName = "Link";
    },
    showCode(){
      this.linkOrCodeContent = this.embedCode;
      this.linkOrCodeTitle =  "Embed link";
      this.linkOrCodeName = "Embed";
    },
    close() {
      this.$store.commit(MUTATION_UPDATE, ["isNonAppDownloadDialogOpen", false]);
      this.$emit('hide');
    },
  }
};
</script>

<style scoped lang="scss">
.iconlist{
  span {
    a {
      padding: 0 !important;
      i {
        font-size: 24px !important;
        //position: relative;
        //top: 2px;
      }
      .pbFont-facebook1{
        color: #425f9b;
      }
      .pbFont-twitter-x-round3{
        color: #000000;
      }
      .pbFont-linkedin2 {
        color: #0077b5;
      }
      .pbFont-tumblr2{
        color: #37455c;
      }
    }
  }
}
.share-dialog {
  position: absolute;
  top: 0;
  background: #f6f6f6;
  width: 100%;
  height: 100%;
  z-index: 9999;
  right: 0;
  left: 0;
  .close{
    color: #f8f8f8;
    &:hover{
      opacity: 0.8;
    }
    &:focus{
      opacity: 0.8;
      outline: -webkit-focus-ring-color auto 1px;
    }
  }
  .share-content {
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 118px;
    padding: 10px;
    .copy-code{
      padding-left: 10px;
      width: 70%;
    }
    ul{
      display: flex;
      align-items: center;
      list-style: none;
      position: relative;
      top: 2.5px;
      justify-content: center;
      padding-inline-start: 0;
      margin-bottom: 0;
      padding-left: 0;
      li{
        a{
         margin-bottom: 0;
         height: 20px;
         line-height: 20px;
          text-decoration:none;
          ::v-deep span{
            width: 20px !important;
            height: 20px !important;
            line-height: 17px !important;
            border-radius: 4px;
            svg{
              width: 20px !important;
              height: 20px !important;
              line-height: 17px !important;
            }
          }
        }
      }
    }
    .icon-group {
      margin-top: 10px;
      a.link{
        padding-left: 0;
      }
      a{
        padding: 0 3px;
        svg{
          border-radius: 4px;
        }
      }
      .subscribe {
        //position: relative;
        //top: -1px;
        text-decoration: none;
        background: #ff3c00;
        border-radius: 4px;
        color: #ffffff !important;
        font-size: 15px;
        width: 24px;
        height: 24px;
        text-align: center;
        margin-left: 3px;
        margin-right: 3px;
        svg{
          width: 15px;
          height: 15px;
        }
      }
      .embed{
        color: #838383;
        //position: relative;
        //top: -1px;
        &:hover,&:focus{
          color: #1a1a1a;
        }
        svg{
          width: 24px;
          height: 24px;
        }
      }
    }
    .form {
      align-items: center;
      .title_panel {
        color: #1a1a1a;
        font-size: 14px;
        margin-bottom: 4px;

      }
      input {
        border-radius: 4px;
        color: #333333;
        font-size: 14px;
        box-shadow: none;
        border: 1px solid #c7c7c7;
        padding: 3px 10px;
        width: 75%;
        box-sizing: border-box;
        height: 29px;
      }
      .copy {
        color: #353535;
        border: 1px solid #dadada;
        padding: 0 8px;
        border-radius: 4px;
        margin-left: 7px;
        display: inline-block;
        line-height: 27px;
        font-size: 12px;
        text-decoration: none;
        transition: all 0.2s;
        background: #ececec;
        &:hover{
         background: #dedede;
        }
      }
      .cancel {
        color: #161616;
        padding: 0 5px;
        margin-left: 0;
        font-size: 14px;
        text-decoration: none;
        &:hover{
          opacity: 0.75;
        }
      }
    }
  }
}
 @media (max-width: 599px) {
   .share-dialog{
     .share-content{
       .copy-code{
         width: auto;
       }
     }
   }
 }
</style>
